import type { ReactNode } from 'react';
import { CheckOutlined, RemoveOutlined } from '@mui/icons-material';
import styles from './SelectionCheckbox.module.css';

export interface SelectionCheckboxProps {
	checked: boolean;
	indeterminate?: boolean;
	onChange: () => void;
	label?: ReactNode;
	ariaLabel?: string;
}

export const SelectionCheckbox = ({
	checked,
	indeterminate,
	onChange,
	label,
	ariaLabel,
}: SelectionCheckboxProps) => {
	const isMarked = checked || indeterminate;
	return (
		<label className={styles.container}>
			<input
				type="checkbox"
				className={styles.input}
				checked={checked}
				onChange={onChange}
				aria-label={ariaLabel}
				aria-checked={indeterminate ? 'mixed' : checked}
			/>
			<span className={`${styles.box} ${isMarked ? styles.boxChecked : ''}`}>
				{indeterminate && !checked ? (
					<RemoveOutlined className={styles.icon} />
				) : (
					checked && <CheckOutlined className={styles.icon} />
				)}
			</span>
			{label && <span className={styles.label}>{label}</span>}
		</label>
	);
};
